module.exports = __webpack_public_path__ + "static/paragraph-3ad85e67f93a4effb5f693edb635bc63.png";